module.exports = __webpack_public_path__ + "static/media/infoJumbo3.066a72fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/demmeler/images/infoJumbo3.jpg
// module id = 478
// module chunks = 0